import { ChainId } from '@oboswap/eth-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x3A43c0bCcb4edc19FEa8E83c80cfc688Da93E7C7', // TODO
  [ChainId.TESTNET]: '0x3A43c0bCcb4edc19FEa8E83c80cfc688Da93E7C7'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
